module.exports = __webpack_public_path__ + "img/doc.bf475117.png";